import BaseModel from './BaseModel';
import Review from './Review';
import Researcher from './Researcher';
import PrismaStats from './PrismaStats';

export default class Revision extends BaseModel {
  constructor(data = {}) {
    super(Revision, data);
    this.id = data.id;
    this.review = data.review ? new Review(data.review) : null;
    this.tagline = data.tagline;
    this.description = data.description;
    this.isPublished = data.isPublished;
    this.publishedAt = data.publishedAt && new Date(data.publishedAt);
    this.publishedBy = data.publishedBy
      ? new Researcher(data.publishedBy)
      : null;
    this.outcome = data.outcome;
    this.createdAt = data.createdAt && new Date(data.createdAt);
    this.updatedAt = data.updatedAt && new Date(data.updatedAt);

    this.newReferencesCount = data.newReferencesCount || 0;
    this.prismaStats =
      data.prismaStats && new PrismaStats(data.prismaStats);
  }
}
